/**
 * Starter Popups
 * Initial popups displayed on map load
 */
import mapboxgl from 'mapbox-gl';
import { createMapPopupElement, type MapPopupProps } from '@/components/molecules/MapPopup';

export interface StarterPopup {
  type: string;
  description: string;
  location: [number, number];
  onPopupClick?: (type: string) => void;
}

const STARTER_POPUPS: StarterPopup[] = [
  {
    type: 'Incident Reported',
    description: 'Six pirates in a speedboat boarded an offshore supply vessel',
    location: [8.17, 1.9849999999999999],
  },
  {
    type: 'Incident Reported',
    description: 'Around seven robbers boarded an anchored heavy load carrier ship.',
    location: [91.79766666666667, 21.594666666666665],
  },
  {
    type: 'Rule Violation',
    description: 'Vessel of MMSI: 525002033 no longer has a valid P&I Club.',
    location: [6.589279500914931, -24.3044157940961],
  },
  {
    type: 'Rule Violation',
    description: 'Chinese vessel of MMSI: 412477020 has entered your Black Sea geofence.',
    location: [29.14381991250237, 41.24885770551876],
  },
  {
    type: 'Rule Violation',
    description: 'Vessel of MMSI: 636009993 is now registered under a flag of convenience.',
    location: [-146.46277023753103, 30.55039574560216],
  },
  {
    type: 'Rule Violation',
    description: 'Vessel of MMSI: 232006620 ISSC compliance is no longer valid.',
    location: [-59.64353223557284, 29.808548076567973],
  },
];

/**
 * Add starter popups to the map
 * @param map - Mapbox map instance
 * @param onPopupClick - Optional callback when popup is clicked
 */
function buildStarterPopupProps(popupData: StarterPopup): MapPopupProps {
  const isIncident = popupData.type.toLowerCase().includes('incident');
  return {
    badge: { label: popupData.type, variant: isIncident ? 'critical' : 'warning' },
    title: isIncident ? 'High-priority incident' : 'Rule violation detected',
    description: popupData.description,
    footer: 'Select to focus area and open relevant panel.',
  };
}

export function addStarterPopups(map: mapboxgl.Map, onPopupClick?: (type: string) => void): void {
  STARTER_POPUPS.forEach((popupData) => {
    const popup = new mapboxgl.Popup({ closeButton: true });

    const popupContent = createMapPopupElement(buildStarterPopupProps(popupData));

    popupContent.addEventListener('click', () => {
      if (onPopupClick) {
        onPopupClick(popupData.type);
      }
      map.flyTo({
        center: popupData.location,
        zoom: 10,
        essential: true,
        offset: [200, 0],
      });
    });

    popup.setLngLat(popupData.location).setDOMContent(popupContent).setMaxWidth('400px').addTo(map);
  });
}
